import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { styleModal, styleModalDark, styleModalFull } from "../../helper/style";

const LiqueModal = ({ open, onClose, children, theme = "default", width = null, noPaddingY = false }) => {
  let modalTheme = {...styleModal};
  if (theme === 'full') {
    modalTheme = {...styleModalFull};
  } else if (theme === 'dark') {
    modalTheme = {...styleModalDark};
  }

  if (width !== null) {
    modalTheme = { ...modalTheme, width: width }
  }

  if (noPaddingY) {
    modalTheme = { ...modalTheme, paddingY: 0 }
  }

  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          TransitionComponent: Fade ,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={modalTheme}>
          {children}
        </Box>
      </Fade>
    </Modal>
  )
};

export default LiqueModal;
